"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _classCallCheck2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));
var _plugin = _interopRequireDefault(require("@ckeditor/ckeditor5-core/src/plugin"));
var _widgetresize = _interopRequireDefault(require("@ckeditor/ckeditor5-widget/src/widgetresize"));
var _videoResizeCommand = _interopRequireDefault(require("./videoResizeCommand.js"));
var VideoResize = exports.default = /*#__PURE__*/function (_Plugin) {
  function VideoResize() {
    (0, _classCallCheck2.default)(this, VideoResize);
    return (0, _callSuper2.default)(this, VideoResize, arguments);
  }
  (0, _inherits2.default)(VideoResize, _Plugin);
  return (0, _createClass2.default)(VideoResize, [{
    key: "init",
    value: function init() {
      var editor = this.editor;
      var command = new _videoResizeCommand.default(editor);
      this._registerSchema();
      this._registerConverters();
      editor.commands.add('videoResize', command);
      editor.editing.downcastDispatcher.on('insert:media', function (evt, data, conversionApi) {
        var widget = conversionApi.mapper.toViewElement(data.item);
        var resizer = editor.plugins.get(_widgetresize.default).attachTo({
          unit: editor.config.get('mediaEmbed.resizeUnit') || '%',
          modelElement: data.item,
          viewElement: widget,
          editor: editor,
          getHandleHost: function getHandleHost(domWidgetElement) {
            return domWidgetElement.querySelector('video');
          },
          getResizeHost: function getResizeHost(domWidgetElement) {
            return domWidgetElement;
          },
          // TODO consider other positions.
          isCentered: function isCentered() {
            var videoStyle = data.item.getAttribute('videoStyle');
            return !videoStyle || videoStyle === 'full' || videoStyle === 'alignCenter';
          },
          onCommit: function onCommit(newValue) {
            editor.execute('videoResize', {
              width: newValue
            });
          }
        });
        resizer.on('updateSize', function () {
          if (!widget.hasClass('media_resized')) {
            editor.editing.view.change(function (writer) {
              writer.addClass('media_resized', widget);
            });
          }
        });
        resizer.bind('isEnabled').to(command);
      }, {
        priority: 'low'
      });
    }
  }, {
    key: "_registerSchema",
    value: function _registerSchema() {
      this.editor.model.schema.extend('media', {
        allowAttributes: 'width'
      });
    }
  }, {
    key: "_registerConverters",
    value: function _registerConverters() {
      var editor = this.editor;

      // Dedicated converter to propagate media's attribute to the img tag.
      editor.conversion.for('downcast').add(function (dispatcher) {
        return dispatcher.on('attribute:width:media', function (evt, data, conversionApi) {
          if (!conversionApi.consumable.consume(data.item, evt.name)) {
            return;
          }
          var viewWriter = conversionApi.writer;
          var figure = conversionApi.mapper.toViewElement(data.item);
          if (data.attributeNewValue !== null) {
            viewWriter.setStyle('width', data.attributeNewValue, figure);
            viewWriter.addClass('media_resized', figure);
          } else {
            viewWriter.removeStyle('width', figure);
            viewWriter.removeClass('media_resized', figure);
          }
        });
      });
      editor.conversion.for('upcast').attributeToAttribute({
        view: {
          name: 'figure',
          styles: {
            width: /.+/
          }
        },
        model: {
          key: 'width',
          value: function value(viewElement) {
            return viewElement.getStyle('width');
          }
        }
      });
    }
  }], [{
    key: "requires",
    get: function get() {
      return [_widgetresize.default];
    }
  }, {
    key: "pluginName",
    get: function get() {
      return 'VideoResize';
    }
  }]);
}(_plugin.default);